import { appConfig } from '@runtime-config'

if (import.meta.env.DEV) {
  console.log(`Loading ${import.meta.env.VITE_APP_ENV || 'dev'} configuration`)
}

// @lat: [[config#Runtime env]]
export const configManager = appConfig
